import React from 'react';

// month -> sections -> days -> items
const ACTIVITY_BY_MONTH = [
  {
    key: 'april',
    month: 'April',
    sections: []
  },
  {
    key: 'may',
    month: 'May',
    sections: [
      {
        title: 'Opening Weekend',
        days: [
          {
            date: '1st',
            items: [
              {
                details: (
                  <>
                    Red Rock Ponds RV Resort opens for the season — welcome back!
                  </>
                )
              }
            ]
          },
          {
            date: '2nd',
            items: [
              {
                time: '8:00PM',
                details: (
                  <>
                    Opening Bonfire Social — Inaugural fire of the season — grab a chair, head up front, and catch up with old friends (or meet some new ones) for an easy, grown-ups campfire hang under the stars.
                  </>
                )
              }
            ]
          },
          {
            date: '3rd',
            items: [
              {
                time: '10:30AM - 11:15AM',
                details: (
                  <>
                    Coffee Social — Coffee and donuts before everyone heads out — swing by for laughs, quick catch-ups, and one last &quot;see you next weekend&quot; lap before the work week kicks in.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: "Mother's Day Weekend",
        days: [
          {
            date: '8th',
            items: [
              {
                time: '5:00PM - 7:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/RedOsierLandmark/" target="_blank" rel="noopener noreferrer">Red Osier</a> — Food Truck — Red Osier is bringing their famous roast beef and comfort-food classics on wheels — grab a plate, skip the cooking, and kick off the weekend full and happy.
                  </>
                )
              }
            ]
          },
          {
            date: '9th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Mother&apos;s Day Crafting (Message-in-a-Jar) — Kids will fill a &quot;love note jar&quot; with sweet (and funny) little messages for Mom — the kind she can pull out all season long when she needs a smile.
                  </>
                )
              },
              {
                time: '3:00PM - 4:00PM',
                details: (
                  <>
                    Mother&apos;s Day Party (Bloom &amp; Laugh) — Join us for a fun spring get-together with snacks, sweet treats, and plenty of good company — a simple, feel-good way to celebrate Mother&apos;s Day at the park.
                  </>
                )
              },
              {
                time: '7:00PM - 8:00PM',
                details: (
                  <>
                    Bingo — Bingo night — lucky marker recommended, bragging rights guaranteed.
                  </>
                )
              }
            ]
          },
          {
            date: '10th',
            items: [
              {
                time: '9:00AM - 10:00AM',
                details: (
                  <>
                    Mother&apos;s Day Breakfast — All you can eat breakfast w/ blueberry pancakes with all the toppings! Coffee and juice available. $4 per person.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: '3rd Weekend of May',
        days: [
          {
            date: '16th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Rock Painting (Annual) — paint a rock for the park or take one home.
                  </>
                )
              }
            ]
          },
          {
            date: '17th',
            items: [
              {
                time: '10:30AM',
                details: (
                  <>
                    Garden Club Meeting — Kickoff meeting for the Red Rock Ponds Garden Club at the Clubhouse — open to all seasonal guests who want to share ideas, plan projects, and meet fellow gardeners ahead of the gardening season.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Memorial Day Weekend',
        days: [
          {
            date: '23rd',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '12:00PM - 1:00PM',
                details: (
                  <>
                    BBQ Cook-Off — Fire up the grills and bring your best — sample, vote, and crown this year&apos;s Red Rock BBQ Champion.
                  </>
                )
              }
            ]
          },
          {
            date: '24th',
            items: [
              {
                time: '7:00PM - 8:00PM',
                details: (
                  <>
                    Bingo — Bingo night — lucky marker recommended, bragging rights guaranteed.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: '5th Weekend of May',
        days: [
          {
            date: '30th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              }
            ]
          },
          {
            date: '31st',
            items: [
              {
                time: '10:30AM',
                details: (
                  <>
                    Garden Club Meeting — Quick get-together at the Clubhouse to discuss front garden plans — open to all seasonal guests who want to weigh in.
                  </>
                )
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'june',
    month: 'June',
    sections: [
      {
        title: 'Poker Weekend',
        days: [
          {
            date: '5th',
            items: [
              {
                time: '5:00PM - 7:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/dubbyswoodfired/" target="_blank" rel="noopener noreferrer">Dubby&apos;s Wood Fired Pizza</a> — Food Truck — Dubby&apos;s is rolling in with handcrafted, wood-fired pies — grab a slice (or three), enjoy the smoky goodness, and let someone else handle dinner.
                  </>
                )
              },
              {
                time: '7:30PM - 10:00PM',
                details: (
                  <>
                    Poker Night — Shuffle up and deal — a fun, low-stakes night of cards, laughs, and bragging rights for whoever runs the table.
                  </>
                )
              }
            ]
          },
          {
            date: '6th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '7:00PM - 8:00PM',
                details: (
                  <>
                    Bingo — Bingo night — lucky marker recommended, bragging rights guaranteed.
                  </>
                )
              }
            ]
          },
          {
            date: '7th',
            items: [
              {
                time: '10:30AM - 11:15AM',
                details: (
                  <>
                    Coffee Social — Coffee and donuts before everyone heads out — swing by for laughs, quick catch-ups, and one last &quot;see you next weekend&quot; lap before the work week kicks in.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Fishing Derby Weekend (Catch & Release)',
        days: [
          {
            date: '12th',
            items: [
              {
                time: '7:30PM - 9:00PM',
                details: (
                  <>
                    Community Fire Night (Adults) — A laid-back late-night bonfire hang — chairs in a circle, good music, and the kind of campground conversations that somehow go on forever.
                  </>
                )
              }
            ]
          },
          {
            date: '13th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '10:30AM - 10:50AM',
                details: (
                  <>
                    Fishing Derby Check-In — quick rules + token pickup.
                  </>
                )
              },
              {
                time: '11:00AM - 1:00PM',
                details: (
                  <>
                    Fishing Derby — Lines in early and bragging rights on the line — join the derby, weigh in your catch, and see who lands the big one.
                  </>
                )
              },
              {
                time: '1:30PM - 2:00PM',
                details: (
                  <>
                    Awards — Most Fish Caught + Longest Fish
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: "Father's Day Weekend",
        days: [
          {
            date: '20th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '10:30AM - 12:30PM',
                details: (
                  <>
                    Father&apos;s Day Crafting (Dad Keychain + Tag) — Kids will make a custom keychain for Dad with a fun little message tag — simple, personal, and actually something he&apos;ll use.
                  </>
                )
              },
              {
                time: '3:00PM - 4:00PM',
                details: (
                  <>
                    Father&apos;s Day Party — Dad&apos;s kind of party — BBQ, laid-back hang time, and a few easy games to keep it fun.
                  </>
                )
              },
              {
                time: '7:00PM - 8:00PM',
                details: (
                  <>
                    Bingo — Bingo night — lucky marker recommended, bragging rights guaranteed.
                  </>
                )
              }
            ]
          },
          {
            date: '21st',
            items: [
              {
                time: '9:00AM - 10:00AM',
                details: (
                  <>
                    Father&apos;s Day Breakfast — All you can eat breakfast w/ blueberry pancakes with all the toppings! Coffee and juice available. $4 per person, fathers eat free.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Campfire Crawl Weekend',
        days: [
          {
            date: '27th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '11:00AM - 12:00PM',
                details: (
                  <>
                    Blood Pressure Clinic — The local fire department stops by to check blood pressure for free — quick, friendly, and a smart way to stay on top of your numbers.
                  </>
                )
              },
              {
                time: '7:00PM',
                details: (
                  <>
                    Campfire Crawl — Visit each designated campfire around the park for good conversation, snacks, and surprises from your hosts — the perfect night to meet neighbors and make the rounds.
                  </>
                )
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'july',
    month: 'July',
    sections: [
      {
        title: '4th of July Weekend',
        days: [
          {
            date: '3rd',
            items: [
              {
                time: '10:00AM - 6:00PM',
                details: (
                  <>
                    Giant Water Slide — Beat the heat and let it rip — the giant slide is out and it&apos;s basically impossible to do this without laughing like a kid.
                  </>
                )
              },
              {
                time: '1:00PM - 3:00PM',
                details: (
                  <>
                    Wagon Rides — Hop on for a classic campground wagon ride — a fun lap around the park to wave at neighbors and kick off the holiday weekend.
                  </>
                )
              }
            ]
          },
          {
            date: '4th',
            items: [
              {
                time: '10:00AM - 6:00PM',
                details: (
                  <>
                    Giant Water Slide — Beat the heat and let it rip — the giant slide is out and it&apos;s basically impossible to do this without laughing like a kid.
                  </>
                )
              },
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '2:00PM - 3:00PM',
                details: (
                  <>
                    4th of July Parade — Deck out your golf cart, bike, or stroller and join the campground parade — flags, music, and peak 4th of July energy all the way around the loop.
                  </>
                )
              },
              {
                details: (
                  <>
                    Ice Cream Social — Right after the parade, swing by for ice cream and a little cooldown — the perfect &quot;parade debrief&quot; with your campground crew.
                  </>
                )
              },
              {
                time: '7:00PM - 10:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/biglogicmusic/" target="_blank" rel="noopener noreferrer">Big Logic &amp; The Truth Serum</a> — Live Music — A Rochester-based rock band that blends rock, funk, soul, reggae, and blues into an upbeat set of originals + smart covers — groove-heavy, crowd-friendly, and built for a summer Saturday night.
                  </>
                )
              }
            ]
          },
          {
            date: '5th',
            items: [
              {
                time: '10:30AM - 11:15AM',
                details: (
                  <>
                    Coffee Social — Coffee and donuts before everyone heads out — swing by for laughs, quick catch-ups, and one last &quot;see you next weekend&quot; lap before the work week kicks in.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: '2nd Weekend of July',
        days: [
          {
            date: '10th',
            items: [
              {
                time: '5:00PM - 7:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/RedOsierLandmark/" target="_blank" rel="noopener noreferrer">Red Osier</a> — Food Truck — Red Osier is bringing their famous roast beef and comfort-food classics on wheels — grab a plate, skip the cooking, and kick off the weekend full and happy.
                  </>
                )
              },
              {
                time: '7:30PM - 9:00PM',
                details: (
                  <>
                    Community Fire Night — Circle up for a classic summer-night bonfire — good music, easy conversation, and that &quot;we&apos;re staying up a little later&quot; campground energy.
                  </>
                )
              }
            ]
          },
          {
            date: '11th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '11:00AM - 12:00PM',
                details: (
                  <>
                    Blood Pressure Clinic — The local fire department stops by to check blood pressure for free — quick, friendly, and a smart way to stay on top of your numbers.
                  </>
                )
              },
              {
                time: '7:00PM - 8:00PM',
                details: (
                  <>
                    Bingo — Bingo night — lucky marker recommended, bragging rights guaranteed.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Day Beach Party Weekend',
        days: [
          {
            date: '18th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '11:00AM - 1:00PM',
                details: (
                  <>
                    Zentangle Workshop — Join Theresa for a hands-on intro to Zentangle, a relaxing form of structured doodling — no experience needed. You&apos;ll learn easy patterns and practice on small tiles, and take home an ink pen, a pencil, and a blending tool to keep creating on your own. $5 per person. Space is limited to 25 — sign up at the office to reserve your spot.
                  </>
                )
              },
              {
                time: '2:00PM',
                details: (
                  <>
                    Wagon Ride — A fun family ride around the park. One ride only — don&apos;t be late!
                  </>
                )
              },
              {
                time: '4:00PM - 6:00PM',
                details: (
                  <>
                    Day Beach Party — Peak summer at the beach — music, games, and a full afternoon of sun-and-lake vibes that turns the shoreline into the place to be.
                  </>
                )
              },
              {
                time: '6:00PM - 7:00PM',
                details: (
                  <>
                    Taco and Nacho Bar — Dinner catered by Sammies N Sweets. Each $18 ticket includes two tacos and one serving of nachos. The bar includes taco beef, taco chicken, soft wraps, hard shells, shredded cheese, lettuce, tomatoes, sour cream, jalape&ntilde;os, guacamole, chipotle sauce, taco sauce, nacho cheese, tortilla chips, and rice. Only 100 tickets available — sign up and pay at the office before they sell out.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Fire Dept Carnival Weekend',
        days: [
          {
            date: '25th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '12:00PM - 3:00PM',
                details: (
                  <>
                    Fire Department Fundraiser Carnival — Carnival day at the park — games, food, raffles, and a whole lot of fun for a great local cause.
                  </>
                )
              }
            ]
          }, 
          {
            date: '26th',
            items: [
              {
                time: '10:00AM',
                details: (
                  <>
                    Garden Club Meeting — Get-together at the Clubhouse to plan our next project and talk deadheading and pruning — open to all seasonal guests who want to join in.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Christmas in July Weekend',
        days: [
          {
            date: '31st',
            items: [
              {
                time: '7:00PM - 10:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/p/The-Who-Dats-100063582307146/">Who Dats</a> - Live Music - Mix of southern rock, funk, dance, and soft rock tunes that cater to all musical tastes!
                  </>
                )
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'august',
    month: 'August',
    sections: [
      {
        title: '',
        days: [
          {
            date: '1st',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '2:00PM - 4:00PM',
                details: (
                  <>
                    Christmas in Summer — Santa&apos;s on vacation — expect festive games, goofy holiday fun, and &quot;Christmas&quot; vibes… just with sunshine instead of snow.
                  </>
                )
              },
              {
                time: '7:00PM - 8:00PM',
                details: (
                  <>
                    Bingo — Bingo night — lucky marker recommended, bragging rights guaranteed.
                  </>
                )
              }
            ]
          },
          {
            date: '2nd',
            items: [
              {
                time: '10:30AM - 11:15AM',
                details: (
                  <>
                    Coffee Social — Coffee and donuts before everyone heads out — swing by for laughs, quick catch-ups, and one last &quot;see you next weekend&quot; lap before the work week kicks in.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Trivia Weekend',
        days: [
          {
            date: '7th',
            items: [
              {
                time: '9:30AM',
                details: (
                  <>
                    Golf Tournament — Annual tournament at Brown Road Golf Club hosted by Mike Stoll (site 237) and Les Eccleston (site 238) — $20 cash entry collected on-site, teams drawn by card at 9:30AM, capped at 36 players so sign up early.
                  </>
                )
              },
              {
                time: '5:00PM - 7:00PM',
                details: (
                  <>
                    <a href="https://www.roccitysammich.com/" target="_blank" rel="noopener noreferrer">Roc City Sammich</a> — Food Truck — Roc City Sammich is rolling in with Rochester-style sandwiches — fresh, filling, and exactly what you want to kick off the weekend without having to fire up the grill.
                  </>
                )
              }
            ]
          },
          {
            date: '8th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '7:00PM - 8:15PM',
                details: (
                  <>
                    Trivia Night — Bring your smartest friends (or your loudest guessers) — team trivia with fun rounds, good laughs, and bragging rights for the winners.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Craft / Yard Show & Sale Weekend',
        days: [
          {
            date: '14th',
            items: [
              {
                time: '7:30PM - 9:00PM',
                details: (
                  <>
                    Community Fire Night — A late-summer bonfire hang — pull up a chair, catch up with friends, and enjoy one of those nights that always seems to fly by.
                  </>
                )
              }
            ]
          },
          {
            date: '15th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '11:00AM - 2:00PM',
                details: (
                  <>
                    Yard Sale + Craft Sale — Sales happen right at individual campsites, so wander the park hunting yard-sale deals and handmade goods.
                  </>
                )
              },
              {
                time: '7:00PM - 8:00PM',
                details: (
                  <>
                    Bingo — Bingo night — lucky marker recommended, bragging rights guaranteed.
                  </>
                )
              }
            ]
          }
        ]
      }, 
      {
        title: 'Night Beach Party Weekend',
        days: [
          {
            date: '21st',
            items: [
              {
                time: '6:00PM - 7:30PM',
                details: (
                  <>
                    Distillery Tasting (Vendor-Hosted) — sample something new and kick off the weekend.
                  </>
                )
              }
            ]
          },
          {
            date: '22nd',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '11:00AM - 12:00PM',
                details: (
                  <>
                    Blood Pressure Clinic — The local fire department stops by to check blood pressure for free — quick, friendly, and a smart way to stay on top of your numbers.
                  </>
                )
              },
              {
                time: '6:00PM - 7:00PM',
                details: (
                  <>
                    Beef on Weck Dinner — New this year — beef on weck served with tri-colored pasta salad + salt potatoes, so you can skip cooking and head straight into a great Saturday night. $13 per person — sign up and pay at the office by Sunday, August 9.
                  </>
                )
              },
              {
                time: '7:00PM - 10:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/salvatore.rock.2025/" target="_blank" rel="noopener noreferrer">Salvatore Rock</a> — Live Music — A high-energy classic + modern rock power trio from Western NY — big guitars, crowd-pleaser covers, and the kind of set that keeps the party rolling.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: '4th Weekend of August',
        days: [
          {
            date: '29th',
            items: [
              {
                time: '9:00AM - 10:00AM',
                details: (
                  <>
                    Pancake Breakfast — All you can eat breakfast w/ blueberry pancakes with all the toppings! Coffee and juice available. $4 per person, kids 5 and under eat free.
                  </>
                )
              },
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '2:00PM - 3:00PM',
                details: (
                  <>
                    Magic Show — A family-friendly magic show with big laughs and &quot;how the heck did they do that?&quot; moments — a perfect Saturday night surprise if we lock it in.
                  </>
                )
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'september',
    month: 'September',
    sections: [
      {
        title: 'Labor Day Weekend',
        days: [
          {
            date: '4th',
            items: [
              {
                time: '5:00PM - 7:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/curbsidequesadilla/" target="_blank" rel="noopener noreferrer">Curbside Quesadilla</a> — Food Truck — Curbside Quesadilla is rolling in with made-to-order quesadillas and nachos — hot off the griddle, fast, and exactly the kind of easy win you want to start Labor Day weekend.
                  </>
                )
              }
            ]
          },
          {
          date: '5th',
          items: [
            {
              time: '10:30AM - 11:30AM',
              details: (
                <>
                  Yoga with Mandy! - All skill levels welcome!
                </>
              )
            },
            {
              time: '11:00AM - 12:00PM',
              details: (
                <>
                  Blood Pressure Clinic — The local fire department stops by to check blood pressure for free — quick, friendly, and a smart way to stay on top of your numbers.
                </>
              )
            },
            {
              time: '6:30PM - 10:00PM',
              details: (
                <>
                  Red Rock Oktoberfest — Oktoberfest at the park — bigger, better this year, great company, and that perfect fall-weekend vibe that turns into everyone hanging out longer than planned.
                </>
              )
            },
            {
              time: '7:00PM - 9:30PM',
              details: (
                <>
                  <a href="https://thepolkaboyz.com/"  target="_blank" rel="noopener noreferrer">The Polka Boyz</a> — Live Music — Bring your crew and get ready to move — The Polka Boyz bring a high-energy polka party that starts as &quot;we&apos;ll just watch for a minute&quot; and ends with half the campground dancing.
                </>
              )
            }
          ]
        },
          {
            date: '6th',
            items: [
              {
                time: '10:30AM - 11:15AM',
                details: (
                  <>
                    Coffee Social — Coffee and donuts before everyone heads out — swing by for laughs, quick catch-ups, and one last &quot;see you next weekend&quot; lap before the work week kicks in.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Cornhole Weekend',
        days: [
          {
            date: '11th',
            items: [
              {
                time: '7:30PM - 9:00PM',
                details: (
                  <>
                    Community Fire Night — One of those perfect early-fall bonfire nights — cooler air, big fire, good music, and the campground &quot;hang&quot; that always turns into a great night.
                  </>
                )
              }
            ]
          },
          {
            date: '12th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '10:30AM - 1:30PM',
                details: (
                  <>
                    Seasonal Group Photo — Seasonals — everyone in! Meet up for our annual group photo and snag a fun keepsake from the summer you basically lived here.
                  </>
                )
              },
              {
                time: '2:00PM - 4:00PM',
                details: (
                  <>
                    Cornhole Tournament — Time to throw down — grab a partner (or get paired up), hit the boards, and see who takes home the cornhole bragging rights.
                  </>
                )
              },
              {
                time: '2:00PM - 4:00PM',
                details: (
                  <>
                    Clambake Fundraiser — One dozen steamed clams with half an ear of corn and drawn butter for $8 per order, served up during Cornhole Weekend. Proceeds benefit our local fire department. Preorders are required — sign up at the office by Saturday, August 29.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Dance Party Weekend',
        days: [
          {
            date: '18th',
            items: [
              {
                time: '5:00PM - 7:00PM',
                details: (
                  <>
                    <a href="https://www.facebook.com/GreenliefsOnTheGo/" target="_blank" rel="noopener noreferrer">Greenlief&apos;s On The Go</a> — Food Truck — Greenlief&apos;s On The Go is back with comfort-food favorites on wheels — grab dinner, eat outside, and enjoy a Friday night that basically runs itself.
                  </>
                ) 
              }
            ]
          },
          {
            date: '19th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '7:00PM',
                details: (
                  <>
                    Dance Party — A Saturday night dance party at the park — good music, good laughs, and the kind of night where &quot;one more song&quot; keeps happening.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: '4th Weekend of September',
        days: [
          {
            date: '26th',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Yoga with Mandy! - All skill levels welcome!
                  </>
                )
              },
              {
                time: '4:00PM',
                details: (
                  <>
                    Batavia Downs — Night at the Races (Self-Drive) — Join fellow Red Rock Ponds guests for a night at the races at Batavia Downs Gaming (Clubhouse, 2nd floor above valet parking) — doors open 4:00PM, first post 5:00PM, with races about every 15 minutes from tiered trackside seating. $45 + tax includes the Carved Prime Rib &amp; Shrimp Buffet, a $25 free play credit, official racing program, and a group photo at the Winner&apos;s Circle. Drive yourself — sign up at the office with payment by Saturday, September 20.
                  </>
                )
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 'october',
    month: 'October',
    sections: [
      {
        title: 'Halloween I',
        days: [
          {
            date: '3rd',
            items: [
              {
                time: '10:30AM - 11:30AM',
                details: (
                  <>
                    Halloween Crafting — Kick off spooky season with a fun Halloween craft — a perfect warm-up before all the costumes, candy, and weekend chaos.
                  </>
                )
              },
              {
                details: (
                  <>
                    Wagon Rides — A fall favorite — hop on the wagon for a ride around the park with crisp air, good views, and peak October campground vibes.
                  </>
                )
              }
            ]
          },
          {
            date: '4th',
            items: [
              {
                time: '10:30AM - 11:15AM',
                details: (
                  <>
                    Coffee Social — Coffee and donuts before everyone heads out — swing by for laughs, quick catch-ups, and one last &quot;see you next weekend&quot; lap before the work week kicks in.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Halloween II / Columbus Day Weekend',
        days: [
          {
            date: '10th',
            items: [
              {
                time: '11:00AM - 12:00PM',
                details: (
                  <>
                    Blood Pressure Clinic — The local fire department stops by to check blood pressure for free — quick, friendly, and a smart way to stay on top of your numbers.
                  </>
                )
              },
              {
                time: '3:00PM',
                details: (
                  <>
                    Trick or Treating — Wear your costumes and meet at the main building. NO vehicles past the main gate after 2:45PM
                  </>
                )
              },
              {
                details: (
                  <>
                    Haunted Lake Trails — Watch your back, watch your sides for what&apos;s lurking in the woods and in the pond!
                  </>
                )
              },
              {
                time: '6:30PM',
                details: (
                  <>
                    Light Tour — Take a wagon ride and check out the awesome decoration throughout the park.
                  </>
                )
              },
              {
                details: (
                  <>
                    Hot Cider and Donuts — Get a cup of hot cider and donuts in between the tour.
                  </>
                )
              },
              {
                details: (
                  <>
                    Vote for the best decorated site! Prize available for 1st, 2nd and 3rd place.
                  </>
                )
              }
            ]
          }
        ]
      },
      {
        title: 'Close-out Blow-out Weekend',
        days: [
          {
            date: '17th',
            items: [
              {
                time: '7:00PM - 9:00PM',
                details: (
                  <>
                    End-of-Season Potluck — let&apos;s use up leftover supplies and end the year together.
                  </>
                )
              }
            ]
          }
        ]
      }
    ]
  }
];



// JavaScript Date month indexes for each schedule month key (0 = January).
const MONTH_INDEX_BY_KEY = {
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9
};

// Export activities data
export { ACTIVITY_BY_MONTH, MONTH_INDEX_BY_KEY };
